import { useEffect } from 'react'
import { supabase } from '@/lib/supabase/browser-client'

export function useTimezoneSetup(workspaceId: string) {
  useEffect(() => {
    const setupTimezone = async () => {
      // Skip if no workspaceId
      if (!workspaceId) return

      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      // Get current workspace
      const { data: workspace } = await supabase
        .from('workspaces')
        .select('timezone')
        .eq('id', workspaceId)
        .single()

      // Update workspace timezone if it's different from current timezone
      if (!workspace?.timezone || workspace.timezone !== timezone) {
        await supabase.from('workspaces').update({ timezone }).eq('id', workspaceId)
      }
    }

    setupTimezone()
  }, [workspaceId])
}
